import React from "react";
import Typography from "@material-ui/core/Typography";
const Language = ({}) => {
  return (
    <React.Fragment>
      <Typography paragraph variant="h4">
        Language
      </Typography>
      <Typography paragraph variant="h5">
        A collaboration through languages.
      </Typography>
      <Typography paragraph variant="body1">
        The Invifo platform and the documentation currently are available in
        English language. Many more languages will be provided as soon as
        possible like Bahasa Indonesia, Spanish, French, Russian, etc.
      </Typography>
    </React.Fragment>
  );
};

export default Language;
